import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {ModalController, ToastController} from '@ionic/angular';
import {BaseClass} from '../../../../classes/base';
import {QuestionConfig} from '../../../../interfaces/process-config.interface';
import {TranslationService} from '../../../../services/translation.service';
import {UtilService} from '../../../../services/util.service';

@Component({
    selector: 'app-date-questions',
    templateUrl: './date-questions.component.html',
    styleUrls: ['./date-questions.component.scss', '../../question-types.component.scss'],
})
export class DateQuestionsComponent extends BaseClass implements OnInit {

    @Input() question: QuestionConfig;
    @Input() formGroup: UntypedFormGroup;
    @Input() isManagerComment: boolean = false;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _modalController: ModalController,
        private _utilService: UtilService,
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
    }

    public setDate(value: string, index: number) {
        const field = 'field' + (index);
        const ind = value.indexOf('T');
        if (ind === -1) {
            return;
        }
        const date: string = value.slice(0, ind);
        this.formGroup.get(field).setValue(date);
    }

    public setDateFromEvent(event: Event, index: number) {
        const value = (event as CustomEvent)?.detail?.value ?? '';
        this.setDate(value, index);
    }
}
